module.exports = __webpack_public_path__ + "img/uavcard_bg.232f12ed.png";